require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// /Users/kristinberlehner/sites/recipe-search/wp-content/themes/nutrition-for-me/node_modules/core-js/fn/object/assign.js
// module id = 47
// module chunks = 0